import React from 'react';

/**
 * CaraLoom wordmark + woven-knot mark.
 *
 * Brand-forward refresh (Feb 2026): the original "loom" knot — two threads
 * woven into one fabric of care — but BOLD. Heavier 3.2u stroke holds up
 * at favicon scale. Signature palette: deep cypress strokes + teal focal
 * dot. Wordmark sits in heavier weight with confident tracking so the
 * lockup reads as a brand, not a wordmark.
 *
 * Renamed from `CareLynkLogo.jsx` to `CaraLoomLogo.jsx` on Feb 24, 2026
 * to align the component name with the V2 brand. Legacy export name
 * `CareLynkLogo` is preserved as an alias for any third-party deep links.
 */
export const CaraLoomLogo = ({ className = '', showWordmark = true, size = 32 }) => {
  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {/* Two woven loops forming a continuous knot — the original mark, bolder. */}
        <path
          d="M9 8C5 8 3 12 5 16C7 20 11 22 16 22C21 22 25 20 27 16C29 12 27 8 23 8C19 8 17 12 16 16C15 20 13 24 9 24C5 24 3 20 5 16"
          stroke="#0E3D3A"
          strokeWidth="3.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {/* The care moment — focal point of the weave. */}
        <circle cx="16" cy="16" r="2.4" fill="#14B8A6" />
      </svg>
      {showWordmark && (
        <span
          className="cn-display font-bold text-[1.5rem] text-cn-primary leading-none"
          style={{ letterSpacing: '-0.02em' }}
        >
          CaraLoom
        </span>
      )}
    </div>
  );
};

// Legacy alias preserved for any external consumers that imported the
// pre-rebrand name. Internal codebase no longer references it.
export const CareLynkLogo = CaraLoomLogo;

export default CaraLoomLogo;
